const initialState = {
    "nombre": "",
    "paterno": "",
    "materno": ""
}

export function personaRdc(state = initialState, action) {
    
    switch (action.type) {
        case "CAMBIAR_NOMBRE":
            return { ...state,
                "nombre": action.nombre,
                "paterno": action.paterno,
                "materno": action.materno
            };
        case "GENERAR_ERROR":
            this.props.test = 0;
            return { ...state,
                "nombre": action.nombre,
                "paterno": action.paterno,
                "materno": action.materno
            };
        default: 
            return state;
    }
    
}


// WEBPACK FOOTER //
// ./src/ej/persona-rdc.js